import { computeAgeTotalRatio } from "../computers";
import { getPercentage } from "../math";
import { type AgeStatsItem } from "../models";

export const computeAgeGenderStats = (
    ageDataArray: AgeStatsItem<number>[],
): { stats: { men: number; women: number; dimensionBreakdown: string }[]; womenPct: string; menPct: string } => {
    let womenTotal = 0;
    let menTotal = 0;

    for (const { men, women } of ageDataArray) {
        womenTotal += women;
        menTotal += men;
    }

    const stats = ageDataArray.map(({ men, women, dimensionBreakdown }) => {
        return {
            men: computeAgeTotalRatio(men, menTotal),
            women: computeAgeTotalRatio(women, womenTotal),
            dimensionBreakdown,
        };
    });

    const womenPct = getPercentage(womenTotal, womenTotal + menTotal);

    return {
        stats,
        womenPct: `${womenPct}%`,
        menPct: `${100 - womenPct}%`,
    };
};
